var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.70662 15.0656H4.83162V14.9406V5.37793V5.25293H4.70662H1.11377H0.98877V5.37793V14.9406V15.0656H1.11377H4.70662ZM3.98285 14.1987H1.83754V6.11985H3.98285V14.1987Z",
    fill: "#1F82FF",
    stroke: "#1F82FF",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0114 15.0656H14.8864H11.2936H11.1686V14.9406V9.69657C11.1686 9.251 10.8189 8.89614 10.3954 8.89614C9.97175 8.89614 9.62215 9.25099 9.62215 9.69657V14.9406V15.0656H9.49715H5.9043H5.7793V14.9406V5.37793V5.25293H5.9043H9.49715H9.62215V5.37793V5.76081C10.143 5.42939 10.7449 5.25253 11.3609 5.25293C11.3609 5.25293 11.3609 5.25293 11.361 5.25293M15.0114 15.0656L14.8864 8.99865C14.8864 7.00127 13.3033 5.37793 11.3609 5.37793L11.361 5.25293M15.0114 15.0656V14.9406V8.99865C15.0114 6.93537 13.3754 5.25298 11.361 5.25293M15.0114 15.0656L11.361 5.25293M14.1625 8.99896V14.1987H12.0173V9.69657C12.0173 8.77918 11.2946 8.02922 10.3954 8.02922C9.49601 8.02922 8.77326 8.77918 8.77326 9.69657V14.1987H6.62807V6.11985H8.77326V7.47551V7.80477L8.99177 7.55847L9.50804 6.97653C9.5081 6.97647 9.50816 6.9764 9.50821 6.97634C10.0023 6.42302 10.6614 6.11985 11.3609 6.11985L11.3611 6.11985C12.9015 6.1178 14.1586 7.40265 14.1625 8.99896Z",
    fill: "#1F82FF",
    stroke: "#1F82FF",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91019 4.88629L2.91045 4.88629C3.97407 4.88411 4.8294 3.99732 4.83162 2.91069V2.91043C4.83162 1.82281 3.9749 0.93457 2.91019 0.93457C1.84548 0.93457 0.98877 1.82281 0.98877 2.91043C0.98877 3.99817 1.84549 4.88629 2.91019 4.88629ZM1.83754 2.91043C1.83754 2.29452 2.32133 1.8016 2.91019 1.8016C3.49906 1.8016 3.98285 2.29452 3.98285 2.91043C3.98285 3.52647 3.49905 4.01938 2.91019 4.01938C2.32133 4.01938 1.83754 3.52647 1.83754 2.91043Z",
    fill: "#1F82FF",
    stroke: "#1F82FF",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b0f8dc6e5da469e2e404d526cba64bac.svg";
export { ForwardRef as ReactComponent };